import { Component } from '@angular/core';
import { ButtonType } from '@shared/ui/buttons';
import { AppConfig } from '@shared/utils/app-config';
import { UrlNavigationService } from '@shared/utils/url-navigation';

@Component({
  selector: 'shared-ui-static-page-download-client',
  templateUrl: './download-client.component.html',
  styleUrls: ['./download-client.component.css'],
  standalone: false,
})
export class DownloadClientComponent {
  buttonType = ButtonType.Primary;
  downloaded: boolean = false;

  constructor(public appConfig: AppConfig, private urlNavigationService: UrlNavigationService) {}

  goToDownloadPage(): void {
    this.downloaded = true;
    this.urlNavigationService.openInNewTab(this.appConfig.statics.downloadLink);
  }
}
